import { thor } from "../../../typings/thor";
import { Events } from "../../../thor.enums";
import { UpsertMediaVideoDialogController } from "./upsert-media-video-dialog.controller";

export class MediaGallerySidenavController {
    public static $inject: string[] = [
        "$log",
        "$mdDialog",
        "$mdMedia",
        "$q",
        "$rootScope",
        "$scope",
        "$translate",
        "dragulaService",
        "mediaGalleryService",
        "mediaService",
        "toaster"
    ];

    // binded
    public close;
    public closeSidenav;
    public resource: thor.ItemGet;
    public readOnly: boolean;

    public isOpen: boolean;

    private canDrag: boolean;

    private $t;

    constructor(
        private $log: ng.ILogService,
        private $mdDialog: ng.material.IDialogService,
        public $mdMedia: ng.material.IMedia,
        private $q: ng.IQService,
        private $rootScope: ng.IRootScopeService,
        $scope: ng.IScope,
        $translate: ng.translate.ITranslateService,
        dragulaService,
        private mediaGalleryService,
        private mediaService,
        private toaster
    ) {
        this.$t = $translate.instant;

        this.canDrag = true;

        dragulaService.options($scope, "media-bag", {
            moves: () => this.canDrag && !this.readOnly
        });

        $scope.$on("media-bag.drop-model", () => {
            this.resetMediasRanks();
        });
    }

    public addMedia(event, files: File[]) {
        this.mediaGalleryService.addMedia(event, files, this.resource);
    }

    public upsertMediaVideo(event, media) {
        this.$mdDialog.show({
            controller: UpsertMediaVideoDialogController,
            controllerAs: "dialogCtrl",
            locals: { media, resource: this.resource },
            template: require("./upsert-media-video-dialog.html"),
            parent: angular.element(document.body),
            targetEvent: event,
            fullscreen: this.$mdMedia("xs")
        });
    }

    public deleteMedia(media, event) {
        const confirm = this.$mdDialog
            .confirm()
            .title(this.$t("confirmation"))
            .textContent(this.$t("souhaitez_vous_supprimer_cette_photo"))
            .targetEvent(event)
            .ok(this.$t("oui"))
            .cancel(this.$t("ne_pas_supprimer"));

        this.$mdDialog
            .show(confirm)
            .then(() => this.mediaService.deleteMedia(media.id))
            .then(() => {
                (this.resource as thor.ItemGet).media_count = (this.resource as thor.ItemGet).media_count - 1;
                this.resource.medias = this.resource.medias.filter(elem => elem !== media);
                return this.resetMediasRanks();
            })
            .then(() => {
                // no check to translations status needed
                if (this.$rootScope.isRouteOnline) {
                    return this.$rootScope.$broadcast(Events.OnlineItemUpdated);
                }
                this.$rootScope.$broadcast(Events.ItemUpdated, this.resource);
                this.$rootScope.$broadcast(Events.PostMessageToV2);
            })
            .catch(error => {
                this.$log.error("Error while deleting the media", error);
            });
    }

    private resetMediasRanks() {
        if (this.resource.medias.length === 0) {
            return;
        }

        const firstMedia = this.resource.medias[0];
        const othersMedias = this.resource.medias.filter((_, index) => index > 0);
        let mediaId = firstMedia.id;

        this.canDrag = false;

        this.mediaService
            .updateMedia(mediaId, { rank: 0 })
            .then(updatedMedia => {
                firstMedia.rank = updatedMedia.rank;

                const promises = othersMedias.map((media, index) =>
                    this.$q((resolve, reject) => {
                        mediaId = media.id;

                        this.mediaService
                            .updateMedia(mediaId, { rank: index + 1 })
                            .then(innerUpdatedMedia => {
                                media.rank = innerUpdatedMedia.rank;
                                resolve();
                            })
                            .catch(error => reject(error));
                    })
                );

                this.$q
                    .all(promises)
                    .then(() => {
                        this.$log.info("Images order has been changed");

                        // no check to translations status needed
                        if (this.$rootScope.isRouteOnline) {
                            return this.$rootScope.$broadcast(Events.OnlineItemUpdated);
                        }
                        this.$rootScope.$broadcast(Events.ItemUpdated, this.resource);
                        this.$rootScope.$broadcast(Events.PostMessageToV2);
                    })
                    .catch(error => {
                        this.$log.error("Cannot update medias", error);
                        this.toaster.toast({ message: this.$t("une_erreur_est_survenue") });
                    })
                    .finally(() => (this.canDrag = true));
            })
            .catch(error => {
                this.$log.error("Cannot update medias", error);
                this.toaster.toast({ message: this.$t("une_erreur_est_survenue") });
                this.canDrag = true;
            });
    }
}
